import { apiUrl } from '../config/api';
import { apiFetch } from './client';

const API_BASE = apiUrl('/api/admin/statistics');

export const getSystemStatistics = async () => {
  const response = await apiFetch(`${API_BASE}/system`, {
    method: 'GET',
    auth: true,
  });
  
  if (!response.ok) {
    throw new Error('Erreur lors de la récupération des statistiques système');
  }
  
  return response.json();
};

export const getUserActivityStats = async (days = 30) => {
  const response = await apiFetch(`${API_BASE}/users?days=${days}`, {
    method: 'GET',
    auth: true,
  });
  
  if (!response.ok) {
    throw new Error('Erreur lors de la récupération des statistiques utilisateurs');
  }
  
  return response.json();
};

export const getPlanStatistics = async () => {
  const response = await apiFetch(`${API_BASE}/plans`, {
    method: 'GET',
    auth: true,
  });
  
  if (!response.ok) {
    throw new Error('Erreur lors de la récupération des statistiques plans');
  }
  
  return response.json();
};
